import { Line, Vector2, Component } from "../Engine";
import { HalfArea, SoccerPlaygroundConfig, Sizes } from "./";

export class GoalZoneArea extends Component {

    leftLine : Line | undefined;
    rightLine : Line | undefined;
    frontLine : Line | undefined;

    constructor(public config: SoccerPlaygroundConfig, public halfArea: HalfArea){
        super();

        const width = Sizes.GoalZoneWidth;
        const height = Sizes.GoalZoneHeight

        const yCoordinate = halfArea === HalfArea.UpperArea ? this.config.topLeftCorner.y : this.config.bottomLeftCorner.y;
        const offsetHeight = halfArea === HalfArea.UpperArea ? height * this.config.conversionFactor : -1 * ((height * this.config.conversionFactor));

        this.leftLine = new Line(
            new Vector2(this.config.centerPoint.x - (width / 2 * this.config.conversionFactor), yCoordinate),
            new Vector2(this.config.centerPoint.x - (width / 2 * this.config.conversionFactor), yCoordinate + offsetHeight)
        );

        this.rightLine = new Line(
            new Vector2(this.config.centerPoint.x + (width / 2 * this.config.conversionFactor), yCoordinate),
            new Vector2(this.config.centerPoint.x + (width / 2 * this.config.conversionFactor), yCoordinate + offsetHeight)
        );

        this.frontLine = new Line(
            new Vector2(this.config.centerPoint.x - (width / 2 * this.config.conversionFactor), yCoordinate + offsetHeight),
            new Vector2(this.config.centerPoint.x + (width / 2 * this.config.conversionFactor), yCoordinate + offsetHeight)
        );

        this.children.push(this.leftLine, this.rightLine, this.frontLine);
    }

}